import { Box, Divider, Stack, Typography } from '@mui/material';
import { ButtonComponent } from 'components/ButtonComponent';
import { fieldType } from 'components/FormCreator/types';
import FormCreatorComponent from 'components/FormCreatorComponent';
import CheckBox from 'components/FormCreatorComponent/inputs/CheckBox';
import { createFormProps } from 'components/FormCreatorComponent/types';
import { withdrawalBalanceSteps } from 'constants/customer-account.constants';
import { pagesEnum } from 'constants/ui.constants';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { withdrawalBalanceTypesForms } from 'sections/CustomerAccounts/forms.types';
import { getWithdrawalFormsValuesByTypeAndStep } from 'sections/CustomerAccounts/helper';
import {
	transferDetailsFinalCustomerBankAccount,
	transferDetailsHouseToAltshulerAccount,
	withdrawalWaitOnHouseAccountApproval,
} from 'services/pending-requests.service';
import { selectTranslations } from 'state/reducers/translation.reducers';

interface IWithdrawBalanceStep2Props {
	balanceRequest: any;
	withdrawalBalanceForm: createFormProps;
	dispatchGetSupportRequest: any;
}

export const WithdrawBalanceStep2 = (props: IWithdrawBalanceStep2Props) => {
	const { balanceRequest, withdrawalBalanceForm, dispatchGetSupportRequest } = props;
	const t = useAppSelector(selectTranslations);
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const [formValues, setFormValues] = useState<Record<string, any>>({});
	const [formState, setFormState] = useState<Record<string, any>>({});
	const isContinueDisabled = useMemo(() => !formState.isValid, [formState]);

	useEffect(() => {
		if (!_.isEmpty(balanceRequest)) {
			const pickFormValues = getWithdrawalFormsValuesByTypeAndStep(
				balanceRequest,
				withdrawalBalanceSteps.WITHDRAWAL_ALTSHULER_CC_TO_BANK_ACCOUNT
			);
			setFormValues(pickFormValues);
		}
	}, [balanceRequest]);

	useEffect(() => {
		if (formState?.values) setFormValues(formState?.values);
	}, [formState]);

	const handleContinue = async () => {
		dispatch(
			transferDetailsHouseToAltshulerAccount({
				balanceRequestId: balanceRequest.id,
				currencyId: formValues.house_account_transfer_currency_id,
				amount: formValues.house_account_transfer_amount,
				altshulerAccountId: formValues.altshuler_account_id,
			})
		)
			.unwrap()
			.then((originalPromiseResult) => {
				waitOnHouseAccountApproval();
				// dispatchGetSupportRequest();
			})
			.catch((rejectedValueOrSerializedError) => {
				// handle error here
				console.log(rejectedValueOrSerializedError);
			});
	};

	const waitOnHouseAccountApproval = async () => {
		dispatch(withdrawalWaitOnHouseAccountApproval({ balanceActivityId: balanceRequest.id! }))
			.unwrap()
			.then((originalPromiseResult) => {
				navigate(`/${pagesEnum.PENDING_REQUESTS}`);
			})
			.catch((rejectedValueOrSerializedError) => {
				// handle error here
				console.log(rejectedValueOrSerializedError);
			});
	};

	return (
		<Box marginTop="40px" maxWidth="664px" paddingLeft="96px">
			{!_.isEmpty(formValues) && withdrawalBalanceForm && (
				<>
					<FormCreatorComponent
						{...withdrawalBalanceForm}
						translation={t}
						values={formValues}
						handleChange={(formState: Record<string, any>) => {
							setFormState(formState);
						}}
					/>
					<Divider sx={{ marginTop: '68px', marginBottom: '20px' }} />
					<Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', marginTop: '48px' }}>
						<ButtonComponent
							styleObj={{ marginLeft: '24px' }}
							disabled={isContinueDisabled}
							text={t(
								`page.withdrawal.forms.${_.snakeCase(
									withdrawalBalanceSteps.WITHDRAWAL_ALTSHULER_CC_TO_BANK_ACCOUNT
								)}.continue_button`
							)}
							handleClick={() => handleContinue()}
						/>
					</Box>
				</>
			)}
		</Box>
	);
};
